import { GridApi } from "ag-grid-community";
import { ChangeEvent } from "react";

type TRulesSelectFilter = Record<string, GridApi>;

const RulesSelectFilter: React.FC<TRulesSelectFilter> = ({ gridApi }) => {
    let selectedType;
    function filterRules(e: ChangeEvent<HTMLSelectElement>) {
        selectedType = e.target.value;
        gridApi.setFilterModel({
            ...(selectedType !== "all" && {
                type: {
                    filterType: "text",
                    type: "equals",
                    filter: selectedType,
                },
            }),
        });
    }
    return (
        <select
            id="rule-overview-type"
            className="mx-3"
            value={selectedType}
            onChange={(e) => filterRules(e)}
            style={{ fontSize: "14px" }}
        >
            <option value="all">All</option>
            <option value="rule">Rule</option>
            <option value="query">Query</option>
        </select>
    );
};

export default RulesSelectFilter;
